import { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { cartActions } from "../../store/cart-slice";
import { ProductContext } from "../../context/ProductContext";
import { getProductTitle } from "../../utils/productDisplayName";

const Container = styled.figure`
  min-height: 80px;
  position: relative;
  background-color: var(--bg-200);
  width: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: var(--spacing-sm);
  box-shadow: var(--shadow-medium);
  margin-bottom: 8px;
`;
const Picture = styled.picture`
  display: flex; // Omogućavanje flex layout-a za centriranje slike
  align-items: center;
  justify-content: center;
  width: 140px;
  max-height: 80px;
  min-height: 80px;
  position: relative;
`;

const Image = styled.img`
  height: 100%;
  max-height: 100%;
  //max-width: 200px;
  width: 80px;
  max-width: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  &.secondary-image {
    display: none;
  }
`;

const Right = styled.div`
  display: grid;
  grid-template-columns: repeat(1fr);
  gap: 8px;
  width: 100%;
  padding-top: 4px;
`;

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;
const P = styled.p`
  padding: 0;
  margin: 0;
  font-size: small;
`;

const InvoiceProduct = ({ item }) => {
  const { currencyTag } = useContext(ProductContext);

  // Try to find a non-primary image; if none exist, use the primary image as fallback
  const primaryImage =
    item.product.images.find((img) => !img.is_primary) ||
    item.product.images.find((img) => img.is_primary);

  return (
    <Container>
      <Picture>
        {primaryImage && (
          <Image
            src={primaryImage.thumbnail}
            alt={getProductTitle(item.product.category_name, item.product.name)}
            srcSet={`${primaryImage.thumbnail} 320w, ${primaryImage.large} 480w, ${primaryImage.large} 800w`}
            sizes="(max-width: 320px) 300px, (max-width: 480px) 440px, 800px"
            loading="lazy"
            className="primary-image"
          />
        )}
      </Picture>
      <Right>
        <FlexDiv style={{ justifyContent: "space-between" }}>
          <h5>
            {getProductTitle(item.product.category_name, item.product.name)}
          </h5>
        </FlexDiv>
        <FlexDiv>
          <P>Number: {item.quantity}</P>
          <h6 style={{ fontFamily: "Gudea-Regural" }}>
            {currencyTag}
            {item.product.discount_price.toFixed(2)}/piece
          </h6>
          <h5>
            {currencyTag}
            {(item.product.discount_price * item.quantity).toFixed(2)}
          </h5>
        </FlexDiv>
      </Right>
    </Container>
  );
};

export default InvoiceProduct;
